import { getStore } from "@/store/storage";

let token = "";
let userInfo = getStore("userInfo");
let valueSet = {};
let messageList = [];
let from = "";
export default {
  token,
  userInfo,
  valueSet,
  messageList,
  from
};
